/**
 * 목록 조회 staleTime — 0이면 같은 조건으로 돌아와도 캐시를 먼저 그리고 뒤에서 다시 받아 갱신한다.
 * 앱 기본값(5분)이면 정렬·페이지를 오갈 때 5분 안의 결과를 그대로 재사용해,
 * 그사이 앱에서 등록된 처방 이미지가 늦게 반영된다.
 */
export const LIST_STALE_TIME = 0;
